<template>
  <div class="input-multi-select">
    <div class="row">
      <div class="col-6">
        <div class="input-multi-select__label">Available {{ label || 'Options' }} ({{ filteredOptions.length }})</div>
        <input class="input-multi-select__filter mb-2" type="text" v-model="filterString" placeholder="Search">
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Selected {{ label || 'Options' }} ({{ value.length }})</div>
      </div>
      <div class="col-6">
        <div class="input-multi-select__options">
          <div
            class="input-multi-select__option"
            v-for="option in filteredOptions"
            :key="option.value"
            @click="selectOption(option.value)"
          >{{ option.label }}</div>
        </div>
      </div>
      <div class="col-6">
        <draggable v-model="selectedOptions" class="input-multi-select__selected">
          <div 
            class="input-multi-select__selected-option"
            v-for="option in selectedOptions"
            :key="option.value"
            @click="unselectOption(option.value)"
          >{{ option.label }}</div>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
export default {
  components: { Draggable },

  props: ['options', 'value', 'label'],

  data () {
    return {
      filterString: ''
    }
  },

  computed: {
    filteredOptions () {
      return _.filter(this.options, option => {
        // Initially filter out already selected values
        if (this.selectedOptionValues.includes(option.value)) {
          return false
        }

        // Then filter based on the filter string
        if (this.filterString.length) {
          return option.label.toLowerCase().includes(this.filterString.toLowerCase())
        } else {
          return true
        }
      })
    },

    selectedOptions: {
      get () {
        // Use the order of selectedOptionValues rather than options, allows draggable to work
        let selectedOptions = []
        this.selectedOptionValues.forEach(selectedOptionValue => {
          const selectedOption = _.find(this.options, option => {
            return option.value === selectedOptionValue
          })

          if (selectedOption) {
            selectedOptions.push(selectedOption)
          }
        })
        return selectedOptions
      },
      set (selectedOptions) {
        this.$emit('input', selectedOptions.map(option => option.value))
      }
    },

    selectedOptionValues () {
      return this.value
    }
  },

  methods: {
    selectOption (value) {
      if (!this.selectedOptionValues.includes(value)) {
        this.selectedOptionValues.push(value)
        this.$emit('input', this.selectedOptionValues)
      }
    },

    unselectOption (value) {
      let newSelectedOptionValues = _.filter(this.selectedOptionValues, selectedOptionValue => {
        return selectedOptionValue === value ? false : true
      })
      this.$emit('input', newSelectedOptionValues)
    }    
  }

}
</script>
<style lang="scss">
.input-multi-select {
  border-radius: 3px;
  border: 1px solid rgba(96, 125, 159, 0.25);
  background-color: #fbfcfe;
  box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
  background-clip: padding-box;
  padding: 15px;
  // display: flex;

  &__filter{
    border: 1px solid #eee;
    border-radius: 4px;
    padding-left: 0.5em;
  }

  &__label {
    font-weight: 300;
    margin-bottom: 0.5em;
  }

  &__options, &__selected {
    // width: 50%;
    border-radius: 4px;
    height: 200px;
    max-height: 200px;
    overflow: auto;
    border: 1px solid #eee;
    padding: 5px 5px 0;
  }

  &__option, &__selected-option {
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>